// extracted by css-extract-rspack-plugin
export default {"space1":"20px","grid":"redeployment-grid__grid___Ki5ee"};